
<v-app>
  <!-- <div class="maintenance">
    Site under maintenance. Please give us a moment.
  </div> -->
  <router-view />
  <notifications group="n" class="notifications" />
</v-app>
